module.exports = __webpack_public_path__ + "static/img/XQZF.a4e9d72.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/leven/XQZF.png
// module id = 2vya
// module chunks = 1